import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';
import { Observable } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { ObservedDefectModel } from '../models/defect.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dropdown-component',
  standalone: true,
  imports: [
    FormsModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    CommonModule,
    MatInputModule,
  ],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DropdownComponent {
  defectList: any[] = [];

  @Input() dropdownType: string;
  @Input() disabled: boolean;
  //dropdown type zone
  @Input() zones: any[] = [];
  @Output() zoneSelected: EventEmitter<string> = new EventEmitter<string>();
  zoneLabel: string = this.qbuiltInspConstants.zoneDropdownLabel;
  zoneSelection: any;
  selectedZone: any;

  //dropdown type defect
  @Input() observedDefectTasks: ObservedDefectModel[] = [];
  @Output() defectSelected: EventEmitter<string> = new EventEmitter<string>();
  defectLabel: string = this.qbuiltInspConstants.odDropdownLabel;
  defectPlaceholder: string = this.qbuiltInspConstants.odDropdownPlaceholder;
  filteredDefects: Observable<ObservedDefectModel[]> = new Observable<
    ObservedDefectModel[]
  >();
  defectControl = new FormControl();

  //dropdown type location
  @Input() locations: any[] = [];
  @Input() defectId: number = 0;
  @Output() locationSelected: EventEmitter<string> = new EventEmitter<string>();
  locationControl = new FormControl();
  locationSelectionValue: any;
  locationLabel: string = this.qbuiltInspConstants.locationLabel;
  locationPlaceholder: string = this.qbuiltInspConstants.locationPlaceholder;

  //dropdown type station
  @Input() stations: any[] = [];
  @Output() stationSelected: EventEmitter<string> = new EventEmitter<string>();
  stationLabel: string = this.qbuiltInspConstants.stationDropdownLabel;
  stationPlaceholder: string =
    this.qbuiltInspConstants.stationDropdownPlaceholder;

  defectFormList: any[] = [];

  //session storage key
  defectItemsKey: string = this.qbuiltInspConstants.defectItemsKey;
  cqmsItemsKey: string = this.qbuiltInspConstants.cqmsItemsKey;

  constructor(public qbuiltInspConstants: QBuiltInspectorConstants) {}

  ngOnInit() {
    this.defectList =
      JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}')
        .defectList || [];
    this.defectFormList =
      JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}')
        .defectFormList || [];

    if (this.dropdownType === 'zone') {
      //populate zones here for particular user
      let selection =
        JSON.parse(sessionStorage.getItem(this.cqmsItemsKey) || '{}').zoneId ||
        null;
      if (selection) {
        this.selectedZone = selection;
      }
    }

    if (this.dropdownType === 'defect') {
      this.filteredDefects = this.defectControl.valueChanges.pipe(
        startWith(''),
        map((value) =>
          value ? this._filter(value) : this.observedDefectTasks.slice(),
        ),
      );
    }
  }

  //used by observed defect filtering to return the filtered value typed by user
  private _filter(value: ObservedDefectModel | string): ObservedDefectModel[] {
    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : value.InspectionTaskName.toLowerCase();
    return this.observedDefectTasks.filter((option) =>
      option.InspectionTaskName.toLowerCase().includes(filterValue),
    );
  }

  //Used by observed defect filtering to display result
  displayFn(option: ObservedDefectModel): string {
    return option && option.InspectionTaskName ? option.InspectionTaskName : '';
  }

  trackByStationId(index: number, station: any): number {
    return station.Id;
  }

  onZoneChange(selectedZone: any) {
    this.zoneSelected.emit(selectedZone.value);
  }

  onDefectChange(selectedDefect: any) {
    this.defectSelected.emit(selectedDefect.option.value);
  }

  onLocationChange(selectedLoc: any) {
    this.locationSelected.emit(selectedLoc.value);
  }

  onStationChange(selectedStation: any) {
    this.stationSelected.emit(selectedStation.value);
  }
}
